<template>
  <div class="page-shell">
    <NoticeModal />
    <div class="page-content">
      <ErrorBoundary>
        <Navigation />
        <slot />
      </ErrorBoundary>
    </div>
    <Footer />
  </div>
</template>

<script lang="ts" setup>
import NoticeModal from "~/components/shared/modals/NoticeModal.vue";
import ErrorBoundary from "~/components/shared/ErrorBoundary.vue";
import Footer from "@/components/shared/Footer.vue";
import Navigation from "@/components/shared/navigation/Navigation.vue";
</script>
